import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { userSchema } from "../../../lib/validations/userValidations";
import {
  createAndUpdateLocationsServer,
  getLocationsServer,
} from "../../../apis/locationsApi";
import { getCategoriesServer } from "../../../apis/categoriesApi";
import { updateUser } from "../../../apis/usersApi";
import TextInputFormik from "../../../lib/common/TextInputFormik";

export default function AddUser() {
  const [loading, setLoading] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [categories, setCategories] = useState([]);
  const [addLocationsInitial, setAddLocationsInitial] = useState({
    name: "",
    email: "",
    address: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      updateUserdata(id);
    }
    // getcategories();
  }, [id]);

  const updateUserdata = async (id) => {
    setEditLoader(true);
    try {
      const res = await updateUser(id);
      if (res.result) {
        setAddLocationsInitial({
          name: `${res?.result?.firstName} ${res?.result?.surname}`,
          email: res?.result?.email,
          address: res?.result?.address1,
        });
      }
    } catch (error) {
      console.error("Error fetching Locations:", error);
    } finally {
      setLoading(false);
    }
    setEditLoader(false);
  };
  const getcategories = async () => {
    try {
      const res = await getCategoriesServer();
      if (res?.result) {
        setCategories(res.result);
      }
    } catch (err) {
      console.error("Failed to fetch categories:", err);
    }
  };
  const formik = useFormik({
    initialValues: addLocationsInitial,
    enableReinitialize: true,
    validationSchema: userSchema,
    onSubmit: async (values) => {
      console.log(values);
      try {
        setLoading(true);
        let res;
        if (id) {
          res = await createAndUpdateLocationsServer(id, values);
          console.log(res);
        } else {
          res = await createAndUpdateLocationsServer(null, values);
        }
        setLoading(false);
        formik.resetForm();
        navigate("/Users");
      } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
      }
    },
  });
  const backClick = () => {
    navigate("/Users");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {" "}
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              {editLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                  {/* Name */}
                  <TextInputFormik label="Name" field="name" formik={formik} />

                  {/* Address */}
                  <TextInputFormik
                    label="Address"
                    field="address"
                    formik={formik}
                  />

                  {/* Email */}
                  <TextInputFormik
                    label="Email"
                    field="email"
                    formik={formik}
                  />

                  {/* Submit button or loading spinner */}
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
